import Icon from '../../components/Icon.vue'

Icon.register({"brands/kickstarter":{"width":448,"height":512,"paths":[{"d":"M400 480H48C21.6 480 0 458.4 0 432V80C0 53.6 21.6 32 48 32H400C426.4 32 448 53.6 448 80V432C448 458.4 426.4 480 400 480zM199.6 178.5C199.6 147.8 182 133.4 159.9 133.4 134.1 133.4 119.9 153.2 119.9 177.9V332.7C119.9 358.5 133.6 378.3 160.4 378.3 181.9 378.3 199.6 364.3 199.6 332.7V290.9L260.2 366.6C272.5 381.5 299.2 383.4 316 366.6 330.6 351.5 330.8 329.8 320 316.2L270.9 253.4 311.4 194.7C320.8 181.2 320.9 160.2 305.8 145.6 289.4 129.7 261.2 128.3 244.4 152.6L199.6 217.3V178.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/kickstarter.js
// module id = Ta0w
// module chunks = 0